import * as React from "react";
import { mergeStyles } from "@fluentui/react";
import { Add20Regular, Board20Filled, CalendarLtr20Filled, ChartMultiple20Filled, ChartMultiple20Regular, Dismiss12Regular, Dismiss16Regular, Stop16Regular, Table20Filled, Table20Regular, Rocket20Filled, Rocket20Regular, EditPerson20Regular, Rocket24Filled, BotAdd20Regular, CopyAdd20Regular } from "@fluentui/react-icons";
import { Add16Regular } from "@fluentui/react-icons";
import { AlertUrgent16Filled } from "@fluentui/react-icons";
import { AlertUrgent20Filled } from "@fluentui/react-icons";
import { AlertUrgent20Regular } from "@fluentui/react-icons";
import { AppsList20Regular } from "@fluentui/react-icons";
import { Apps16Regular } from "@fluentui/react-icons";
import { ArrowClockwise16Regular } from "@fluentui/react-icons";
import { ArrowDown16Regular } from "@fluentui/react-icons";
import { ArrowDown20Regular } from "@fluentui/react-icons";
import { ArrowLeft20Regular } from "@fluentui/react-icons";
import { ArrowMaximize20Regular } from "@fluentui/react-icons";
import { ArrowRepeatAll16Regular } from "@fluentui/react-icons";
import { ArrowRepeatAll20Regular } from "@fluentui/react-icons";
import { ArrowReset20Regular } from "@fluentui/react-icons";
import { ArrowRight20Regular } from "@fluentui/react-icons";
import { ArrowSortDownLines20Regular } from "@fluentui/react-icons";
import { GroupList20Regular } from "@fluentui/react-icons";
import { ArrowUp16Regular } from "@fluentui/react-icons";
import { ArrowUpload20Regular } from "@fluentui/react-icons";
import { Attach16Regular } from "@fluentui/react-icons";
import { Attach20Regular } from "@fluentui/react-icons";
import { Board20Regular } from "@fluentui/react-icons";
import { BoardSplit20Filled } from "@fluentui/react-icons";
import { BoardSplit20Regular } from "@fluentui/react-icons";
import { CalendarDay20Regular } from "@fluentui/react-icons";
import { CalendarPerson24Regular } from "@fluentui/react-icons";
import { CalendarEmpty20Regular } from "@fluentui/react-icons";
import { CalendarLtr16Regular } from "@fluentui/react-icons";
import { CalendarLtr20Regular } from "@fluentui/react-icons";
import { CalendarToday20Regular } from "@fluentui/react-icons";
import { CalendarWorkWeek20Regular } from "@fluentui/react-icons";
import { Chat16Regular } from "@fluentui/react-icons";
import { Chat20Regular } from "@fluentui/react-icons";
import { Checkmark16Regular } from "@fluentui/react-icons";
import { CheckmarkCircle16Filled } from "@fluentui/react-icons";
import { CheckmarkCircle16Regular } from "@fluentui/react-icons";
import { CheckmarkCircle20Filled } from "@fluentui/react-icons";
import { CheckmarkCircle20Regular } from "@fluentui/react-icons";
import { ChevronDown16Regular } from "@fluentui/react-icons";
import { ChevronDown20Filled } from "@fluentui/react-icons";
import { ChevronDown20Regular } from "@fluentui/react-icons";
import { ChevronLeft12Regular } from "@fluentui/react-icons";
import { ChevronLeft20Regular } from "@fluentui/react-icons";
import { ChevronLeft28Regular } from "@fluentui/react-icons";
import { ChevronRight12Regular } from "@fluentui/react-icons";
import { ChevronRight16Regular } from "@fluentui/react-icons";
import { ChevronRight20Regular } from "@fluentui/react-icons";
import { ChevronRight28Regular } from "@fluentui/react-icons";
import { ChevronUp20Regular } from "@fluentui/react-icons";
import { Circle16Regular } from "@fluentui/react-icons";
import { Circle20Filled } from "@fluentui/react-icons";
import { Circle20Regular } from "@fluentui/react-icons";
import { CircleHalfFill16Regular } from "@fluentui/react-icons";
import { CircleHalfFill20Regular } from "@fluentui/react-icons";
import { CircleSmall20Filled } from "@fluentui/react-icons";
import { CircleSmall20Regular } from "@fluentui/react-icons";
import { Clock20Regular } from "@fluentui/react-icons";
import { ColumnArrowRight20Regular } from "@fluentui/react-icons";
import { CommentMultiple20Regular } from "@fluentui/react-icons";
import { Copy20Regular } from "@fluentui/react-icons";
import { DataBarHorizontal20Regular } from "@fluentui/react-icons";
import { Delete16Regular } from "@fluentui/react-icons";
import { Delete20Regular } from "@fluentui/react-icons";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { DismissCircle20Filled } from "@fluentui/react-icons";
import { DismissCircle20Regular } from "@fluentui/react-icons";
import { DividerTall16Regular } from "@fluentui/react-icons";
import { DocumentPdf20Regular } from "@fluentui/react-icons";
import { Edit20Regular } from "@fluentui/react-icons";
import { ErrorCircle20Regular } from "@fluentui/react-icons";
import { Eye20Regular } from "@fluentui/react-icons";
import { EyeOff20Regular } from "@fluentui/react-icons";
import { Filter20Regular } from "@fluentui/react-icons";
import { GanttChart24Regular } from "@fluentui/react-icons";
import { Trophy20Regular } from "@fluentui/react-icons";
import { Trophy20Filled } from "@fluentui/react-icons";
import { Grid20Filled } from "@fluentui/react-icons";
import { Grid20Regular } from "@fluentui/react-icons";
import { Home20Regular } from "@fluentui/react-icons";
import { HomeCheckmark20Filled } from "@fluentui/react-icons";
import { HomeCheckmark20Regular } from "@fluentui/react-icons";
import { Image20Regular } from "@fluentui/react-icons";
import { Important16Filled } from "@fluentui/react-icons";
import { Important20Filled } from "@fluentui/react-icons";
import { Important20Regular } from "@fluentui/react-icons";
import { Info16Regular } from "@fluentui/react-icons";
import { Info20Regular } from "@fluentui/react-icons";
import { Info24Regular } from "@fluentui/react-icons";
import { Link20Regular } from "@fluentui/react-icons";
import { LinkDismiss16Regular } from "@fluentui/react-icons";
import { LockClosed20Regular } from "@fluentui/react-icons";
import { MoreHorizontal20Filled } from "@fluentui/react-icons";
import { MoreHorizontal20Regular } from "@fluentui/react-icons";
import { MoreVertical20Regular } from "@fluentui/react-icons";
import { Navigation20Regular } from "@fluentui/react-icons";
import { Open20Regular } from "@fluentui/react-icons";
import { PanelLeftContract20Regular } from "@fluentui/react-icons";
import { PanelRightContract20Regular } from "@fluentui/react-icons";
import { People20Regular } from "@fluentui/react-icons";
import { People28Regular } from "@fluentui/react-icons";
import { PeopleCommunity20Regular } from "@fluentui/react-icons";
import { Person20Regular } from "@fluentui/react-icons";
import { PersonAdd20Regular } from "@fluentui/react-icons";
import { PersonFeedback20Regular } from "@fluentui/react-icons";
import { PersonArrowLeft20Regular } from "@fluentui/react-icons";
import { PeopleTeamAdd20Regular } from "@fluentui/react-icons";
import { Phone20Regular } from "@fluentui/react-icons";
import { Pin20Filled } from "@fluentui/react-icons";
import { Pin20Regular } from "@fluentui/react-icons";
import { PinOff20Filled } from "@fluentui/react-icons";
import { PlugConnected20Regular } from "@fluentui/react-icons";
import { PinOff20Regular } from "@fluentui/react-icons";
import { Premium20Regular } from "@fluentui/react-icons";
import { Question20Regular } from "@fluentui/react-icons";
import { QuestionCircle20Regular } from "@fluentui/react-icons";
import { ReOrderDotsVertical16Regular } from "@fluentui/react-icons";
import { Search20Regular } from "@fluentui/react-icons";
import { Star20Filled } from "@fluentui/react-icons";
import { Star20Regular } from "@fluentui/react-icons";
import { Send20Regular } from "@fluentui/react-icons";
import { Send20Filled } from "@fluentui/react-icons";
import { Subtract20Regular } from "@fluentui/react-icons";
import { Tag20Regular } from "@fluentui/react-icons";
import { TaskListLtr20Regular } from "@fluentui/react-icons";
import { TaskListLtr20Filled } from "@fluentui/react-icons";
import { Warning20Regular } from "@fluentui/react-icons";
import { WeatherSunny20Filled } from "@fluentui/react-icons";
import { WeatherSunny16Regular } from "@fluentui/react-icons";
import { WeatherSunny20Regular } from "@fluentui/react-icons";
import { Folder20Regular } from "@fluentui/react-icons";
import { Folder20Filled } from "@fluentui/react-icons";
import { FolderOpen20Regular } from "@fluentui/react-icons";
import { Document20Regular } from "@fluentui/react-icons";
import { Timeline20Regular } from "@fluentui/react-icons";
import { List20Regular } from "@fluentui/react-icons";
import { ApprovalsApp20Filled } from "@fluentui/react-icons";
import { SquareDismiss20Regular } from "@fluentui/react-icons";
import { AddCircle20Regular } from "@fluentui/react-icons";
import { AddCircle16Regular } from "@fluentui/react-icons";
import { CalendarAdd20Regular } from "@fluentui/react-icons";
import { Share20Regular } from "@fluentui/react-icons";
import { Sparkle20Filled } from "@fluentui/react-icons";
import { Globe20Regular } from "@fluentui/react-icons";
import { WordLogo } from "./svgs/WordLogo";
import { ExcelLogo } from "./svgs/ExcelLogo";
import { OneNoteLogo } from "./svgs/OneNoteLogo";
import { OutlookLogo } from "./svgs/OutlookLogo";
import { PowerPointLogo } from "./svgs/PowerPointLogo";
import { ProjectLogo } from "./svgs/ProjectLogo";
import { FormsLogo } from "./svgs/FormsLogo";
import { VisioLogo } from "./svgs/VisioLogo";
import { FormsLogoFilled } from "./svgs/FormsLogoFilled";
import { CopilotLogo } from "./svgs/CopilotLogo";
import { PortfolioLogo } from "./svgs/PortfolioLogo";
import { LoopLogoMono } from "./svgs/LoopLogoMono";
import { CircleSparkle } from "./svgs/CircleSparkle";
import { SharepointLogo } from "./svgs/SharepointLogo";
import { SharepointRegularLogo } from "./svgs/SharepointRegularLogo";
import { SharepointRegularDarkLogo } from "./svgs/SharepointRegularDarkLogo";
import { SharepointRegularHighContrastLogo } from "./svgs/SharepointRegularHighContrastLogo";
import { Sparkle } from "./svgs/Sparkle";
import { SparkleFilled } from "./svgs/SparkleFilled";
import { AIGoalTrophyIcon } from "./svgs/AIGoalTrophyIcon";
import { PlannerLogo } from "./svgs/PlannerLogo";
import { PlannerLogoOutline } from "./svgs/PlannerLogoOutline";
import { highContrastColor } from "../utilities/HighContrast.styles";
const svgIconClassname = mergeStyles({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}, highContrastColor());
const makeSvgIconElement = (IconComponent)=>/*#__PURE__*/ React.createElement(IconComponent, {
        className: svgIconClassname
    });
// Icons used in Planner by default
const PlannerIconsSet = {
    plannerAdd: makeSvgIconElement(Add20Regular),
    plannerAddSmall: makeSvgIconElement(Add16Regular),
    plannerAppsList: makeSvgIconElement(AppsList20Regular),
    plannerAssign: makeSvgIconElement(PersonAdd20Regular),
    plannerAssignTeam: makeSvgIconElement(PeopleTeamAdd20Regular),
    plannerBarChart: makeSvgIconElement(DataBarHorizontal20Regular),
    plannerBlocked: makeSvgIconElement(Subtract20Regular),
    plannerBoardSplitFilled: makeSvgIconElement(BoardSplit20Filled),
    plannerBoardSplitRegular: makeSvgIconElement(BoardSplit20Regular),
    plannerCalendar: makeSvgIconElement(CalendarLtr20Regular),
    plannerCalendarFilled: makeSvgIconElement(CalendarLtr20Filled),
    plannerCalendarPerson: makeSvgIconElement(CalendarPerson24Regular),
    plannerCalendarAdd: makeSvgIconElement(CalendarAdd20Regular),
    plannerChatRegular: makeSvgIconElement(Chat20Regular),
    plannerCheckMark: makeSvgIconElement(Checkmark16Regular),
    plannerChevronDown: makeSvgIconElement(ChevronDown20Regular),
    plannerChevronDownMed: makeSvgIconElement(ChevronDown20Filled),
    plannerChevronDownSmall: makeSvgIconElement(ChevronDown16Regular),
    plannerChevronLeft: makeSvgIconElement(ChevronLeft20Regular),
    plannerChevronLeftExtraSmall: makeSvgIconElement(ChevronLeft12Regular),
    plannerChevronLeftLarge: makeSvgIconElement(ChevronLeft28Regular),
    plannerChevronRight: makeSvgIconElement(ChevronRight20Regular),
    plannerChevronRightSmall: makeSvgIconElement(ChevronRight16Regular),
    plannerChevronRightExtraSmall: makeSvgIconElement(ChevronRight12Regular),
    plannerChevronRightLarge: makeSvgIconElement(ChevronRight28Regular),
    plannerChevronUp: makeSvgIconElement(ChevronUp20Regular),
    plannerCommentMultiple: makeSvgIconElement(CommentMultiple20Regular),
    plannerCompleted: makeSvgIconElement(CheckmarkCircle20Regular),
    plannerCopy: makeSvgIconElement(Copy20Regular),
    plannerDelete: makeSvgIconElement(Delete20Regular),
    plannerDeleteSmall: makeSvgIconElement(Delete16Regular),
    plannerDismiss: makeSvgIconElement(Dismiss20Regular),
    plannerDismissSmall: makeSvgIconElement(Dismiss16Regular),
    plannerDismissExtraSmall: makeSvgIconElement(Dismiss12Regular),
    plannerDismissCircle: makeSvgIconElement(DismissCircle20Regular),
    plannerDismissCircleFilled: makeSvgIconElement(DismissCircle20Filled),
    plannerDiamond: makeSvgIconElement(Premium20Regular),
    plannerDivider: makeSvgIconElement(DividerTall16Regular),
    plannerDot: makeSvgIconElement(CircleSmall20Filled),
    plannerDown: makeSvgIconElement(ArrowDown20Regular),
    plannerDownSmall: makeSvgIconElement(ArrowDown16Regular),
    plannerColumnArrowRightIcon: makeSvgIconElement(ColumnArrowRight20Regular),
    plannerExpand: makeSvgIconElement(ArrowMaximize20Regular),
    plannerEdit: makeSvgIconElement(Edit20Regular),
    plannerError: makeSvgIconElement(ErrorCircle20Regular),
    plannerEyeHide: makeSvgIconElement(Eye20Regular),
    plannerEyeOff: makeSvgIconElement(EyeOff20Regular),
    plannerFavoriteStar: makeSvgIconElement(Star20Regular),
    plannerFavoriteStarFilled: makeSvgIconElement(Star20Filled),
    plannerFilter: makeSvgIconElement(Filter20Regular),
    plannerGantt: makeSvgIconElement(GanttChart24Regular),
    plannerGoals: makeSvgIconElement(Trophy20Regular),
    plannerGoalsFilled: makeSvgIconElement(Trophy20Filled),
    plannerGroup: makeSvgIconElement(PeopleCommunity20Regular),
    plannerHome: makeSvgIconElement(Home20Regular),
    plannerImage: makeSvgIconElement(Image20Regular),
    plannerInfoLarge: makeSvgIconElement(Info24Regular),
    plannerInfo: makeSvgIconElement(Info20Regular),
    plannerInfoSmall: makeSvgIconElement(Info16Regular),
    plannerLeft: makeSvgIconElement(ArrowLeft20Regular),
    plannerLink: makeSvgIconElement(Link20Regular),
    plannerLinkDismiss: makeSvgIconElement(LinkDismiss16Regular),
    plannerLock: makeSvgIconElement(LockClosed20Regular),
    plannerMore: makeSvgIconElement(MoreHorizontal20Regular),
    plannerMoreFilled: makeSvgIconElement(MoreHorizontal20Filled),
    plannerMoreVertical: makeSvgIconElement(MoreVertical20Regular),
    plannerMove: makeSvgIconElement(ArrowRight20Regular),
    plannerMyDayFilled: makeSvgIconElement(WeatherSunny20Filled),
    plannerMyDayRegularSmall: makeSvgIconElement(WeatherSunny16Regular),
    plannerMyDayRegular: makeSvgIconElement(WeatherSunny20Regular),
    plannerMyPlansFilled: makeSvgIconElement(Grid20Filled),
    plannerMyPlansRegular: makeSvgIconElement(Grid20Regular),
    plannerMyTasksFilled: makeSvgIconElement(HomeCheckmark20Filled),
    plannerMyTasksRegular: makeSvgIconElement(HomeCheckmark20Regular),
    plannerNavigation: makeSvgIconElement(Navigation20Regular),
    plannerOpenInNewWindow: makeSvgIconElement(Open20Regular),
    plannerPanelLeftContract: makeSvgIconElement(PanelLeftContract20Regular),
    plannerPanelRightContract: makeSvgIconElement(PanelRightContract20Regular),
    plannerPdf: makeSvgIconElement(DocumentPdf20Regular),
    plannerPeople: makeSvgIconElement(People20Regular),
    plannerPeopleLarge: makeSvgIconElement(People28Regular),
    plannerPerson: makeSvgIconElement(Person20Regular),
    plannerPersonArrowLeft: makeSvgIconElement(PersonArrowLeft20Regular),
    plannerPersonFeedback: makeSvgIconElement(PersonFeedback20Regular),
    plannerPhone: makeSvgIconElement(Phone20Regular),
    plannerPin: makeSvgIconElement(Pin20Regular),
    plannerPinFilled: makeSvgIconElement(Pin20Filled),
    plannerPinOff: makeSvgIconElement(PinOff20Regular),
    plannerPinOffFilled: makeSvgIconElement(PinOff20Filled),
    plannerPlugConnected: makeSvgIconElement(PlugConnected20Regular),
    plannerPlanHub: makeSvgIconElement(Circle20Regular),
    plannerQuestion: makeSvgIconElement(Question20Regular),
    plannerQuestionCircle: makeSvgIconElement(QuestionCircle20Regular),
    plannerRecents: makeSvgIconElement(Clock20Regular),
    plannerRecurrence: makeSvgIconElement(ArrowRepeatAll20Regular),
    plannerRecurrenceSmall: makeSvgIconElement(ArrowRepeatAll16Regular),
    plannerReOrderDotsVertical: makeSvgIconElement(ReOrderDotsVertical16Regular),
    plannerRetry: makeSvgIconElement(ArrowClockwise16Regular),
    plannerRevToggle: makeSvgIconElement(ArrowReset20Regular),
    plannerSend: makeSvgIconElement(Send20Regular),
    plannerSendFilled: makeSvgIconElement(Send20Filled),
    plannerSortLines: makeSvgIconElement(ArrowSortDownLines20Regular),
    plannerGroupList: makeSvgIconElement(GroupList20Regular),
    plannerSearch: makeSvgIconElement(Search20Regular),
    plannerStopSmall: makeSvgIconElement(Stop16Regular),
    plannerTag: makeSvgIconElement(Tag20Regular),
    plannerTaskList: makeSvgIconElement(TaskListLtr20Regular),
    plannerTaskListFilled: makeSvgIconElement(TaskListLtr20Filled),
    plannerTaskboard: makeSvgIconElement(Board20Regular),
    plannerTaskboardFilled: makeSvgIconElement(Board20Filled),
    plannerUnknown: makeSvgIconElement(QuestionCircle20Regular),
    plannerUpload: makeSvgIconElement(ArrowUpload20Regular),
    plannerUpSmall: makeSvgIconElement(ArrowUp16Regular),
    plannerApprovalsAppFilled: makeSvgIconElement(ApprovalsApp20Filled),
    plannerSquareDismiss: makeSvgIconElement(SquareDismiss20Regular),
    plannerTable: makeSvgIconElement(Table20Regular),
    plannerTableFilled: makeSvgIconElement(Table20Filled),
    plannerChart: makeSvgIconElement(ChartMultiple20Regular),
    plannerChartFilled: makeSvgIconElement(ChartMultiple20Filled),
    plannerEditPerson: makeSvgIconElement(EditPerson20Regular),
    plannerAttach: makeSvgIconElement(Attach20Regular),
    plannerAddAgent: makeSvgIconElement(BotAdd20Regular),
    plannerPublishTemplate: makeSvgIconElement(CopyAdd20Regular),
    // Task progress icons
    plannerProgressNotStarted: makeSvgIconElement(Circle20Regular),
    plannerProgressInProgress: makeSvgIconElement(CircleHalfFill20Regular),
    plannerProgressComplete: makeSvgIconElement(CheckmarkCircle20Filled),
    plannerProgressNotStartedSmall: makeSvgIconElement(Circle16Regular),
    plannerProgressInProgressSmall: makeSvgIconElement(CircleHalfFill16Regular),
    plannerProgressCompleteSmall: makeSvgIconElement(CheckmarkCircle16Filled),
    // Priority icons
    plannerPriorityUrgent: makeSvgIconElement(AlertUrgent20Filled),
    plannerPriorityImportant: makeSvgIconElement(Important20Filled),
    plannerPriorityMedium: makeSvgIconElement(CircleSmall20Filled),
    plannerPriorityLow: makeSvgIconElement(ArrowDown20Regular),
    plannerPriorityLowSmall: makeSvgIconElement(ArrowDown16Regular),
    plannerPriorityUrgentSmall: makeSvgIconElement(AlertUrgent16Filled),
    plannerPriorityImportantSmall: makeSvgIconElement(Important16Filled),
    plannerPriorityUrgentNoFill: makeSvgIconElement(AlertUrgent20Regular),
    plannerPriorityImportantNoFill: makeSvgIconElement(Important20Regular),
    plannerPriorityMediumNoFill: makeSvgIconElement(CircleSmall20Regular),
    // Small icons (for task card indicators)
    plannerAttachSmall: makeSvgIconElement(Attach16Regular),
    plannerCalendarSmall: makeSvgIconElement(CalendarLtr16Regular),
    plannerChatSmall: makeSvgIconElement(Chat16Regular),
    plannerChecklistSmall: makeSvgIconElement(CheckmarkCircle16Regular),
    plannerAppsSmall: makeSvgIconElement(Apps16Regular),
    // Due Date icons
    plannerDueDateLate: makeSvgIconElement(Warning20Regular),
    plannerDueDateToday: makeSvgIconElement(CalendarToday20Regular),
    plannerDueDateTomorrow: makeSvgIconElement(CalendarDay20Regular),
    plannerDueDateWeek: makeSvgIconElement(CalendarWorkWeek20Regular),
    plannerDueDateNoDate: makeSvgIconElement(CalendarEmpty20Regular),
    // File icons
    plannerWordLogo: makeSvgIconElement(WordLogo),
    plannerExcelLogo: makeSvgIconElement(ExcelLogo),
    plannerOneNoteLogo: makeSvgIconElement(OneNoteLogo),
    plannerOutlookLogo: makeSvgIconElement(OutlookLogo),
    plannerPowerPointLogo: makeSvgIconElement(PowerPointLogo),
    plannerProjectLogo: makeSvgIconElement(ProjectLogo),
    plannerFormsLogo: makeSvgIconElement(FormsLogo),
    plannerVisioLogo: makeSvgIconElement(VisioLogo),
    plannerFormsLogoFilled: makeSvgIconElement(FormsLogoFilled),
    // OneDriveList icons
    plannerOpenFolder: makeSvgIconElement(FolderOpen20Regular),
    plannerFolder: makeSvgIconElement(Folder20Regular),
    plannerDocument: makeSvgIconElement(Document20Regular),
    // Portfolio icons
    portfolioStatusIcon: makeSvgIconElement(Circle20Filled),
    portfolioFolderIcon: makeSvgIconElement(Folder20Regular),
    portfolioFolderFilledIcon: makeSvgIconElement(Folder20Filled),
    portfolioFolderListIcon: makeSvgIconElement(PortfolioLogo),
    // CreatePlan icons
    timelineIcon: makeSvgIconElement(Timeline20Regular),
    listIcon: makeSvgIconElement(List20Regular),
    copilotIcon: makeSvgIconElement(CopilotLogo),
    projectManagerIcon: makeSvgIconElement(PlannerLogo),
    // Project Home Icons
    addCircleIcon: makeSvgIconElement(AddCircle20Regular),
    addCircleIconSmall: makeSvgIconElement(AddCircle16Regular),
    loopIcon: makeSvgIconElement(LoopLogoMono),
    plannerLogoFilledIcon: makeSvgIconElement(PlannerLogo),
    plannerLogoOutlineIcon: makeSvgIconElement(PlannerLogoOutline),
    plannerLogoFilledLargeIcon: makeSvgIconElement(PlannerLogo),
    /** @deprecated Use plannerLogoOutlineIcon */ rocketLogoIcon: makeSvgIconElement(Rocket20Regular),
    /** @deprecated Use plannerLogoFilledIcon */ rocketLogoFilledIcon: makeSvgIconElement(Rocket20Filled),
    /** @deprecated Use plannerLogoFilledLargeIcon */ rocketLogoFilledLargeIcon: makeSvgIconElement(Rocket24Filled),
    globeIcon: makeSvgIconElement(Globe20Regular),
    // AI Task and Goal Icons
    plannerCircleSparkle: makeSvgIconElement(CircleSparkle),
    plannerSparkle: makeSvgIconElement(Sparkle20Filled),
    plannerSparkleRegular: makeSvgIconElement(Sparkle),
    plannerSparkleFilled: makeSvgIconElement(SparkleFilled),
    plannerAITrophy: makeSvgIconElement(AIGoalTrophyIcon),
    //Status Report Icons
    shareIcon: makeSvgIconElement(Share20Regular),
    sharepointIcon: makeSvgIconElement(SharepointLogo),
    sharepointRegularIcon: makeSvgIconElement(SharepointRegularLogo),
    sharepointRegularDarkIcon: makeSvgIconElement(SharepointRegularDarkLogo),
    sharepointRegularHighContrastIcon: makeSvgIconElement(SharepointRegularHighContrastLogo)
};
export const PlannerIcons = {
    icons: PlannerIconsSet
};
